var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6663 4.33334V14.0833C21.6663 15.2326 21.2097 16.3348 20.3971 17.1475C19.5844 17.9601 18.4822 18.4167 17.3329 18.4167H7.48977L10.1981 21.125L8.66627 22.6568L3.34277 17.3333L8.66627 12.0098L10.1981 13.5417L7.48977 16.25H17.3329C17.9076 16.25 18.4587 16.0217 18.865 15.6154C19.2713 15.2091 19.4996 14.658 19.4996 14.0833V4.33334H21.6663Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.d01ed3c06a34f18930a7ac817933812e.svg";
export { ForwardRef as ReactComponent };